import React, { createContext } from 'react';
import { is, isNil,filter, pipe, not, either,uniq, contains, pickBy,flatten, split,map,ifElse,identity } from 'ramda';



import { get } from '../../utils/utils';
import jss, { SheetsManager } from 'jss';
import main from '../../less/main.js';
import blockProperties from '../../less/blockProperties';
import textProperties from '../../less/textProperties';
import preset from 'jss-preset-default';
import { defaults } from "./../../utils";
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
import classnames from 'classnames/bind';
import { Map } from 'immutable'

const env = process.env.NODE_ENV


const createGenerateId = () => {
  let ruleCounter = 0
  const defaultPrefix = env === 'production' ? 'c' : ''

  return (rule, sheet) => {
    if(rule.key === 'sygyIsolateDiv') return rule.key;

    ruleCounter += 1

    let prefix = defaultPrefix
    let jssId = ''

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id
    }

    if (env === 'production') {
      return `${prefix}${jssId}${ruleCounter}`
    }

    return `${prefix + rule.key}${jssId && `-${jssId}`}-${ruleCounter}`
  }
}


jss.setup({ ...preset(), insertionPoint: document.getElementById('availInsertionJSSPoint'), createGenerateId });
const manager = new SheetsManager();

const ThemeContext = React.createContext({});
let keys = new Map();

export const withTheme = (styleFile, fileKey, defaultKey, escape) => Child => {
  return class extends React.Component {
    static displayName = 'themeProvider(' + Child.displayName + ')';

    render() {

      return (
        <ThemeContext.Consumer>
          {theme => {
            const escapeDefaultStyle = get(['config', 'defaultStyle'], this.props) === false || escape === false;
            const styleMethod = theme.styleGetter(styleFile, fileKey, defaultKey, escapeDefaultStyle);
            const styleMethodEscape = theme.styleGetter(styleFile, fileKey, defaultKey, true);
            return (
              <Child
                {...this.props}
                theme={{
                  bind : theme.bind(styleFile),
                  styleGetterEscape: styleMethodEscape,
                  styleGetter: styleMethod,
                  computedInnerStyle: styleMethod(get(['config', 'innerStyle'], this.props)),
                  width: theme.innerWidth,
                  height: theme.innerHeight,
                  deviceType: theme.deviceType,
                  uaDeviceType: theme.uaDeviceType,
                  isMobile: theme.isMobile,
                  getDesirableWidth:theme.getDesirableWidth,
                  isTablet: theme.isTablet,
                  isDesk: theme.isDesk,
                  isTactileDevice: theme.isTactileDevice,
                  theme: theme.theme
                }}
              />
            );
          }}
        </ThemeContext.Consumer>
      );
    }
  };
};

export const withThemeJSS = (
  { styleFile, displayName, link, index = 100, meta = null },
  fileKey,
  defaultKey,
  escape
) => Child => {
  const baseDisplayName = displayName || Child.displayName;

  return class extends React.Component {
    constructor(props, context) {
      super(props);
      this.displayNameWithapp = context.appId || '' + baseDisplayName+context.version;
      const key = keys.get(this.displayNameWithapp) || {};
      let jssSheet = manager.get(key);

      if (!jssSheet) {
        manager.add(
          key,
          context.parseStyles(styleFile, { link, index, meta: meta || this.displayNameWithapp })
        );
        jssSheet = manager.get(key);
        keys  = keys.set(this.displayNameWithapp, key);
      }

      const escapeDefaultStyle = get(['config', 'defaultStyle'], props) === false || escape === false;
      const styleMethod = context.styleGetter(jssSheet.classes, fileKey, defaultKey, escapeDefaultStyle);

      this.state = {
        styleMethod,
        styleMethodEscape: context.styleGetter(jssSheet.classes, fileKey, defaultKey, true),
        jssSheet
      };
    }

    static contextType = ThemeContext;
    static displayName = 'themeJSSProvider(' + Child.displayName + ')';

    componentWillUnmount() {
      //manager.unmanage(this.displayNameWithapp);
    }

    componentDidMount() {
      //manager.manage(this.displayNameWithapp);
    }

    render() {
      const { styleMethod, styleMethodEscape, jssSheet } = this.state;

      return (
        <ThemeContext.Consumer>
          {(theme) => {
            return (
              <Child
                {...this.props}
                theme={{
                  bind : theme.bind(jssSheet.classes),
                  width: theme.innerWidth,
                  height: theme.innerHeight,
                  deviceType: theme.deviceType,
                  uaDeviceType: theme.uaDeviceType,
                  isMobile: theme.isMobile,
                  isTablet: theme.isTablet,
                  isDesk: theme.isDesk,
                  isTactileDevice: theme.isTactileDevice,
                  getDesirableWidth:theme.getDesirableWidth,
                  theme: theme.theme,
                  styleGetterEscape: styleMethodEscape,
                  styleGetter: styleMethod,
                  computedInnerStyle: styleMethod(get(['config', 'innerStyle'], this.props)),
                  styles: jssSheet,
                  themeValues: theme.themeValues,
                  modelDevice: theme.modelDevice,
                  resizableImages:theme.themeValues.resizableImages
                }}
              />);
          }}
        </ThemeContext.Consumer>
      );
    }
  };
};

class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    window.addEventListener('resize', this.onChangeSize);

    this.state = {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      deviceType: this.deviceType(),
      version:"",
      isolate: props.config.value.isolate || 0
    };

    const textPropertiesSheet = this.parseStyles(textProperties, { meta: 'textProperties' });
    const blockPropertiesSheet = this.parseStyles(blockProperties, { meta: 'blockProperties' });
    const mainSheet = this.parseStyles(main, { meta: 'main' });

    this.sharedStyles = {
      ...textPropertiesSheet.classes,
      ...blockPropertiesSheet.classes,
      ...mainSheet.classes
    };

    this.theme = props.config.theme || "defaultTheme";

    this.state.themeValues = defaults((props.config && pickBy((value) => !!value, props.config.themeValues)) || {}, {
      mainColor: '#c94',
      secondColor: '#5ca70a',
      thirdColor: '#4a90e2',
      backgroundColor: '#00111b',
      backgroundEngine: '#00111b',
      calendarColor: '#c94',
      colorFont: '#00111B',
      engineColorFont:'#c94',
      headerColorFont:'#c94',
      headerColorIcons:'#c94',
      headerColorDynamicText:'#fff',
      fontFamily1: 'Roboto , sans-serif',
      fontFamily2: 'DroidSerif',
      fontFamily3: 'Icons',
      fontFamily4: 'Montserrat , sans-serif',
      defaultColor: '#000',
      resizableImages: false,
      STgoldTier: '#AB9662',
      STsilverTier: '#9EA9AE',
      STblueTier: '#2258a4',
      STdefaultTier: '#201b37',
      modalBreak: 801,
    });


    //props.value.appId+"_theme_values"
    window.document.addEventListener("themeValues", this.overrideThemeValues);
  }



  componentDidUpdate(prevProps, prevState) {

    //actualizar themeValues
    if(this.props.config.themeValues && prevProps.config.themeValues !== this.props.config.themeValues){
      this.overrideThemeValues({detail: this.props.config.themeValues})
    }
    //actualizar theme
    if(this.props.config.theme && prevProps.config.theme !== this.props.config.theme){
      this.theme = this.props.config.theme
    }
    //actualizar isolate
    if(this.props.config.isolate && prevProps.config.isolate !== this.props.config.isolate){
      this.setState({isolate: this.props.config.isolate})
    }

  }

  overrideThemeValues = (newThemeValues) => {
    this.setState({
      version : newThemeValues.detail.version,
      themeValues:defaults(newThemeValues.detail, this.state.themeValues)
    }, () => {
      //reescribir hoja de estilos
      keys.forEach(key => {
        const jssSheet = manager.get(key);
        jssSheet.update(this.state.themeValues)
      })

    })
  }



  onChangeSize = () => {
    this.setState(state => {
      if (state.innerHeight !== window.innerHeight || state.innerWidth !== window.innerWidth) {
        return {
          ...state,
          innerHeight: window.innerHeight,
          innerWidth: window.innerWidth,
          deviceType: this.deviceType()
        };
      }
    });
  };

  styleGetter = theme => (styleFile, fileKey, defaultClassKey, ecapeDefaultStyle) => style => {
    let result = [];
    if (!isNil(styleFile)) {
      fileKey = fileKey || 'styleFile'; //clase per defecte q s'aplicara al component en cas de no tenir estil aplicat
      defaultClassKey = defaultClassKey || 'defaultStyle'; // fitxer destil utilitzat per el component

      result.push(!ecapeDefaultStyle && styleFile[defaultClassKey]);
      if(styleFile[theme]) {
        result.push(styleFile[theme]);
      }
      if(styleFile[this.deviceType()]){
        result.push(styleFile[this.deviceType()]);
      }
      if (style) {
        style = is(Array, style) ? style : [style];
        const lol = pipe(map(ifElse((val)=>!!val, split(" "), identity)), flatten, map((subStyle)=> styleFile[subStyle] || subStyle))(style);
        result = [...result, ...lol];
      }
    }

    return pipe(filter(pipe(either(isNil, (val)=> val === false), not)), uniq)(result).join(" ");
  };

  deviceType = () => {
    if (window.innerWidth > 800) {
      return 'DESK';
    } else if (window.innerWidth > 600) {
      return 'TABLET';
    } else {
      return 'MOBIL';
    }
  };

  deviceTypeByUserAgent = () => {
    if (navigator.userAgent.match(/Tablet|iPad/i)) {
      return 'TABLET';
    } else if (
      navigator.userAgent.match(
        /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i
      )
    ) {
      return 'MOBIL';
    } else {
      return 'DESK';
    }
  };

  bind = (styleFile) => ()=> {
    return classnames.bind(styleFile);
  }

  isMobile = () => {
    return !!(this.deviceType() === 'MOBIL');
  }

  isTablet = () => {
    return !!(this.deviceType() === 'TABLET');
  }

  isDesk = () => {
    return !!(this.deviceType() === 'DESK');
  }

  isTactileDevice = () => {
    return !!(this.deviceType() === 'MOBIL' || this.deviceType() === 'TABLET' )
  }

  getDesirableWidth = (width, height) => {
    const relWidth =height ? height / 3 * 4 : 0;
    const finalWidth = Math.max(width, relWidth);
    if (finalWidth >= 1250) {
      return '?width=1500&height=1125';
    } else if (finalWidth >= 950) {
      return '?width=1300&height=975';
    } else if (finalWidth >= 550) {
      return '?width=950&height=713';
    } else if (finalWidth >= 350) {
      return '?width=600&height=450';
    } else if (finalWidth >= 250) {
      return '?width=400&height=300';
    } else if (finalWidth >= 200) {
      return '?width=300&height=225';
    } else if (finalWidth >= 100) {
      return '?width=250&height=188';
    } else if (finalWidth === 0) {
      return '?width=400&height=300';
    } else {
      return '?width=150&height=113';
    }
  }

  modelDevice = () => {
    if (contains("iPhone", navigator.userAgent)) {
      return 'iPhone';
    } else {
      return null;
    }
  };

  parseStyles = (styles, options) => {

    if(is(Function, styles)){
      styles = styles(this.state.themeValues);
    }

    const isolate = this.state.isolate;
    if(isolate && isolate > 0) {

      var childStyles = styles ? Object.keys(styles).reduce((acc, key) => {
        if (key.includes('@global')) return acc;
        else if (key[0] === '@') acc['& ' + key.toString()] = styles[key];
        else acc['& $' + key.toString()] = styles[key];
        return acc;
      }, {}) : styles;

      let isolated = { ...childStyles }
      for (let i = isolate; i > 0; i--) {
        isolated = { [`& #sygyIsolateDiv${i}`]: { ...isolated } };
      }

      styles = {
        ...styles,
        sygyIsolateDiv: {
          ...isolated
        }
      }

    }

    if (options.link) {
      const StyleSheet = jss.createStyleSheet(styles, options);
      StyleSheet.classes = { ...this.sharedStyles, ...StyleSheet.classes };
      StyleSheet.update(this.state.themeValues).attach();
      return StyleSheet;
    } else {
      const StyleSheet = jss.createStyleSheet(styles, options);
      StyleSheet.classes = { ...this.sharedStyles, ...StyleSheet.classes };
      return StyleSheet.attach();
    }
  };

  render() {
    const { state, props } = this;
    const { children } = props;

    return (
      <React.Fragment>
        <ThemeContext.Provider
          value={{
            ...this.props.config,
            bind : this.bind,
            styleGetter: this.styleGetter(this.theme),
            innerHeight: state.innerHeight,
            innerWidth: state.innerWidth,
            deviceType: state.deviceType,
            uaDeviceType: this.deviceTypeByUserAgent(),
            isMobile: this.isMobile,
            isTablet: this.isTablet,
            isDesk: this.isDesk,
            isTactileDevice: this.isTactileDevice,
            getDesirableWidth : this.getDesirableWidth,
            parseStyles: this.parseStyles,
            themeValues: this.state.themeValues,
            modelDevice: this.modelDevice(),
            theme: this.theme,
            version:this.state.version
          }}>
          {this.state.isolate > 0 ? (
            <div className={`sygyIsolateDiv`}>
              {Array.from({ length: this.state.isolate }).reduce((acc, _, i) => <div id={`sygyIsolateDiv${this.state.isolate - i}`}>{acc}</div>, children)}
            </div>
          ) : (
            children
          )}
        </ThemeContext.Provider>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const engineConfigs = contextualizeAppConfig(store, hotelId, "engine_config");

  let themeValues = engineConfigs.get( 'theme_values', ownProps.value.themeValues);
  let postions = engineConfigs.get('positions')
  let button_positions = engineConfigs.get('button_positions')
  const isolate = engineConfigs.get('isolate')


  themeValues = Map.isMap(themeValues) ? themeValues.toJS() : themeValues;
  postions = postions && Map.isMap(postions) ? postions.toJS() : postions;
  button_positions = button_positions && Map.isMap(button_positions) ? button_positions.toJS() : button_positions;

  themeValues = {...themeValues, ...postions, ...button_positions}
  themeValues = defaults((themeValues && pickBy((value) => !!value, themeValues)) || {}, {
    mainColor: '#c94',
    secondColor: '#5ca70a',
    thirdColor: '#4a90e2',
    backgroundColor: '#00111b',
    backgroundEngine: '#00111b',
    calendarColor: '#c94',
    colorFont: '#00111B',
    engineColorFont:'#c94',
    headerColorFont:'#c94',
    headerColorIcons:'#c94',
    headerColorDynamicText:'#fff',
    fontFamily1: 'Roboto , sans-serif',
    fontFamily2: 'DroidSerif',
    fontFamily3: 'Icons',
    fontFamily4: 'Montserrat , sans-serif',
    defaultColor: '#000',
    resizableImages: false,
    STgoldTier: '#AB9662',
    STsilverTier: '#9EA9AE',
    STblueTier: '#2258a4',
    STdefaultTier: '#201b37',
    modalBreak: 801,
  })

  return {
    appId: ownProps.appId,
    themeValues: themeValues,
    theme: engineConfigs.get( 'theme', ownProps.value.theme),
    isolate:isolate,
  }
}
export default compose(
  connect(
    mapStateToProps,
),
  PropertyManager(['appId', 'theme', 'themeValues','value','isolate']),

)(ThemeProvider);

